export default __webpack_public_path__ + "static/media/data.3a9f0c89.png";